import ui from "./ui.js";
import materials from "./materials.js";
import {gsap} from "gsap";


export default function options(model, originalMaterial, scene, camera){
    const {leatherRadios, materialRadios} = ui()
    let firstLoadForLeather = true
    let firstLoadForMaterial = true
    const priceValue = document.querySelector('.price-value')

    const defaultPrice = 200

    const {materialBlackPainted, materialWood} = materials(scene)
    const urlParams = new URLSearchParams(window.location.search);

    const leatherParam = urlParams.get('leather');
    const legsParam = urlParams.get('legs');


    leatherRadios.forEach((item)=>{
        if (leatherParam === item.value && firstLoadForLeather) {
            item.checked = true
            changeColor(leatherParam)
            firstLoadForLeather = false
        }

        item.addEventListener('change', event => {
            changeColor(event.target.value)
        });

        function changeColor(data){
            calculatePrice()

            model.traverse( (child) => {
                if (child.isMesh) {
                    if (child.material.name === 'modern_arm_chair_01_pillow') {
                        if (data === 'default'){
                            child.material.color.set('#FFFFFF')
                            child.material.color.multiplyScalar(1)
                            child.material.needsUpdate = true
                            return
                        }

                        child.material.color.set(data)
                        child.material.color.multiplyScalar(30)
                        child.material.needsUpdate = true
                    }

                    gsap.to(camera.position, {
                        x: 0.3,
                        y: 2,
                        z: 0.6,
                        duration: 0.7,
                        ease: 'power2.out',
                        onUpdate: () => {
                            camera.updateProjectionMatrix()
                        }
                    })
                }
            });
        }
    })

    materialRadios.forEach((item)=>{
        if (legsParam === item.value && firstLoadForMaterial) {
            item.checked = true
            changeMaterial(legsParam)
            firstLoadForMaterial = false
        }

        item.addEventListener('change', event => {
            changeMaterial(event.target.value)
        })

        function changeMaterial(data){
            calculatePrice()

            model.traverse( (child) => {
                if (child.isMesh) {
                    if (child.material.name === 'modern_arm_chair_01_legs') {
                        if (data === 'default'){
                            child.material = originalMaterial
                        }

                        if (data === 'black'){
                            child.material = materialBlackPainted
                            child.material.name = 'modern_arm_chair_01_legs'
                        }
                        if (data === 'wood'){
                            child.material = materialWood
                            child.material.name = 'modern_arm_chair_01_legs'
                        }
                    }

                    gsap.to(camera.position, {
                        x: -1.3,
                        y: 0.75,
                        z: 0.75,
                        duration: 0.7,
                        ease: 'power2.out',
                        onUpdate: () => {
                            camera.updateProjectionMatrix()
                        }
                    })
                }
            })
        }
    })

    function calculatePrice(){
        let price = defaultPrice
        leatherRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        materialRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        priceValue.textContent = price

    }
}